import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.scss']
})
export class FilterBoxComponent implements OnInit {

  // Keep the existing default while allowing screens to clarify what their filter searches.
  @Input() label = 'Filter';
  @Input() data?: FilterData[];
  @Input() initialValue?: string;
  @Output() changed = new EventEmitter<any>();
  @Output() selected = new EventEmitter<FilterData>();

  @ViewChild('filterBox') filterBox!: ElementRef;
  @ViewChild('results') results!: ElementRef;

  valueFilter?: string | null;
  filteredValues?: FilterData[];

  filterCtrl = new FormControl('');

  /**
   * Starts the debounced filter stream and applies an optional caller-provided initial value.
   */
  ngOnInit(): void {
    this.filterCtrl.valueChanges
      .pipe(
        debounceTime(300),     // adjust as needed
        distinctUntilChanged()
      )
      .subscribe(val => this.applyFilter(val));

    if (this.initialValue) this.filterCtrl.setValue(this.initialValue);
  }

  applyFilter(e: any) {
    if (!e) {
      this.valueFilter = '';
      this.filteredValues = undefined;
      this.filterCtrl.setValue(null);
    }
    else this.valueFilter = e;
    if (!this.data && (this.valueFilter?.length ?? 0) >= 1 || !this.valueFilter)
      this.changed.emit(this.valueFilter);
    else {
      if (this.valueFilter) {
        this.filteredValues = this.data?.filter(x => this.valueFilter ? x.text.toLowerCase().includes(this.valueFilter.toLowerCase()) : false);
        const width = this.filterBox?.nativeElement.clientWidth;
        this.results.nativeElement.style.width = width + 'px';
      }
      else this.filteredValues = undefined;
    }
  }

  isNegativeFilter(term: string): boolean {
    return term?.trim().startsWith('-');
  }


  itemSelected(i: FilterData) {
    this.selected.emit(i);
  }
}

export interface FilterData {
  id: number;
  text: string;
}
